<template>
  <div class="sale_des">
    <div class="tit">寄售角色说明</div>
    <p>将现有的游戏角色或账号暂时寄存在官方交易平台，客服核实截图上架，所有玩家都可以进行购买，买家购买后，联系客服进行发货</p>
    <van-button class="know" round color="var(--theme)" @click="close">我已知晓</van-button>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  computed: {},
  created () {},
  mounted () {},
  methods: {
    close() {
        this.$emit('closeModal')
    }
  },
  watch: {},
}
</script>

<style lang="less" scoped>
.sale_des {
    z-index: 100000;
    padding: 2.4rem 2.6rem;
    background-color: #fff;
    .tit {
        text-align: center;
        font-size: 1.6rem;
        font-weight: 700;
        color: #fe6455;
        margin-bottom: 2rem;
    }
    p {
        font-size: 1.4rem;
        color: #555;
        line-height: 1.5;
        margin-bottom: 2.2rem;
    }
    .know {
        width: 100%;
        height: 3.2rem;
        font-size: 1.6rem;
    }
}
</style>
